import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Svg from 'src/components/Svg';
import GuestScreenFooter from './GuestScreenFooter';
import GuestScreenParticles from './GuestScreenParticles';
import Styled from './GuestScreen.styles';
import styles from './styles.css';

const GuestScreen = ({ children }) => {
  return (
    <Fragment>
      <GuestScreenParticles />
      <Styled.GuestScreenContianer className="l-login">
        <div className="login__logo">
          <Svg className={styles.logo} name="eiq-assess-lrqa-logo" />
        </div>
        {children}
        <GuestScreenFooter />
      </Styled.GuestScreenContianer>
    </Fragment>
  );
};

GuestScreen.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.null,
    PropTypes.node,
  ]),
};

export default GuestScreen;
